import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Route is /organizations/$organizationId/settings: the legacy path of the
 * organization preferences page. It permanently forwards to /preferences (the renamed
 * route) so existing bookmarks and links keep resolving; the page itself lives at the
 * new path.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/settings")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { organizationId: params.organizationId },
      to: "/organizations/$organizationId/preferences",
    });
  },
});
